// @flow

export type NextPlanActionType =
  | {|
      type: 'SET_NEXT_PLAN',
      payload: {| nextPlan: Object |},
    |}
  | {|
      type: 'FETCH_NEXT_PLAN',
      payload: {| subscription: Object |},
    |};

export const setNextPlan = (nextPlan: Object): NextPlanActionType => ({
  type: 'SET_NEXT_PLAN',
  payload: { nextPlan },
});

export const fetchNextPlan = (subscription: Object): NextPlanActionType => ({
  type: 'FETCH_NEXT_PLAN',
  payload: { subscription },
});
